import { render } from "./Soins.vue?vue&type=template&id=4adf9f8b&scoped=true"
import script from "./Soins.vue?vue&type=script&lang=js"
export * from "./Soins.vue?vue&type=script&lang=js"

import "./Soins.vue?vue&type=style&index=0&id=4adf9f8b&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adf9f8b"]])

export default __exports__